import { useMatch } from 'react-router-dom'

const usePcodeMatch = () => {
  //billletter
  const bill_letter_ab = useMatch('/bill/:pCode/:slot/:requestId/:telecom/0')
  const bill_letter_default = useMatch('/bill/:pCode/:requestId/:telecom/0')
  const bill_letter = bill_letter_ab ?? bill_letter_default
  const bill_letter_01 = bill_letter?.params.pCode === 'bill-letter_01'
  const bill_letter_02 = bill_letter?.params.pCode === 'bill-letter_02'
  const bill_letter_03 = bill_letter?.params.pCode === 'bill-letter_03'

  const default_join_ab = useMatch('/:form/:pCode/:slot/:requestId/:telecom')
  const default_join_default = useMatch('/:form/:pCode/:requestId/:telecom')
  const default_join = default_join_ab ?? default_join_default
  const mkt_co_gg_13_1_1 = default_join?.params?.pCode === 'mkt_co_gg_13_1_1'
  const nmp_e01 = default_join?.params?.pCode === 'nmp_e01'
  const tnk_01 = default_join?.params?.pCode === 'tnk_01'

  return {
    bill_letter,
    bill_letter_01,
    bill_letter_02,
    bill_letter_03,
    default_join,
    mkt_co_gg_13_1_1,
    nmp_e01,
    tnk_01,
  }
}
export default usePcodeMatch
